module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ciMQY"))).then(() => parcelRequire('jaIvX'));